var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel",class:{shown: _vm.value}},[(_vm.value)?_c('div',{staticClass:"bckgrnd",style:({zIndex: _vm.zIndex}),on:{"click":_vm.handleClickOutside}}):_vm._e(),_c('div',{staticClass:"content",style:({
			width: _vm.width+'px',
			right: '-'+(_vm.value ? 0 : _vm.width)+'px',
			zIndex: _vm.zIndex+1
		})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }